// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyCard_faculty-card-wrapper__L9a3p {
  height: 100%;
}

.FacultyCard_faculty-card__MRP2q {
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}
.FacultyCard_faculty-card__MRP2q div:empty {
  display: none;
}
.FacultyCard_faculty-card__top__6luiv {
  display: flex;
  align-items: center;
  gap: 20px;
  align-self: stretch;
}
.FacultyCard_faculty-card__body__jDN5C {
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
.FacultyCard_faculty-card__body--item__OiqrN {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}
.FacultyCard_faculty-card__body--item--title__3w1uo {
  color: var(--grey-text);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.FacultyCard_faculty-card__body--item--value__m6tJs {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  align-self: stretch;
  color: var(--grey-text);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.FacultyCard_faculty-card__body__left__UVFya {
  display: flex;
  padding-right: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0;
}
.FacultyCard_faculty-card__body__right__wcj85 {
  max-width: 319px;
  padding-left: 16px;
  border-left: 1px solid var(--accent-color-medium);
}
.FacultyCard_faculty-card__bottom__8cphp {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_link__Mwq9K {
  cursor: pointer;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_link__Mwq9K:hover {
  text-decoration: underline;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_avatar__ds59P {
  width: 60px;
  aspect-ratio: 1/1;
  border-radius: 8px;
  object-fit: cover;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_faculty-name__URrsv {
  color: var(--explore-color);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  /* 100% */
  letter-spacing: 0.4px;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_faculty-name--wrapper__qcLnW {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 1;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_entity-actions__X3RXw {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_entity-actions__X3RXw .MuiButton-root {
  box-sizing: border-box;
  min-width: 130px;
  min-height: 36px;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_favorite-btn__ABQx0 {
  text-transform: uppercase;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_statistics__6AvOn .FacultyCard_statistic__AQPgf {
  display: flex;
  align-items: center;
  gap: 4px;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_statistics__6AvOn .FacultyCard_statistic__AQPgf svg {
  width: 32px;
  height: 32px;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_statistics__6AvOn .FacultyCard_statistic__AQPgf svg path {
  stroke: var(--accent-color-medium);
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_keywords__6FeME {
  max-height: 118px;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_keywords__6FeME span {
  color: var(--grey-text);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_keywords__6FeME .FacultyCard_keywords--item__Ps3B5 {
  display: flex;
  padding: 6px 12px;
  align-items: center;
  border-radius: 20px;
  background: var(--light-grey);
  color: var(--grey-text);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  box-shadow: none;
  text-transform: initial;
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_keywords__6FeME .FacultyCard_keywords--item__Ps3B5.FacultyCard_clickable__EYGb1 {
  background: var(--accent-color-light);
  color: var(--text-1);
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_keywords__6FeME .FacultyCard_keywords--item__Ps3B5.FacultyCard_clickable__EYGb1:hover {
  background: var(--accent-color);
  color: var(--text-0);
}
.FacultyCard_faculty-card__MRP2q .FacultyCard_experience-information__YLwRr {
  display: flex;
  font-size: 13px;
  color: var(--blue);
  margin-top: 5px;
  padding: 4px 8px;
}
@media only screen and (max-width: 480px) {
  .FacultyCard_faculty-card__MRP2q .FacultyCard_institution__s1Fxv {
    font-size: 14px;
    font-weight: bold;
  }
}

.FacultyCard_modal__qJErz .FacultyCard_modal-title__U0vjn {
  display: flex;
  align-items: center;
  gap: 16px;
  color: var(--accent-color);
}
.FacultyCard_modal__qJErz .FacultyCard_modal-title--avatar--photo__YdIth {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
}
.FacultyCard_modal__qJErz .FacultyCard_modal-title--name__rxdPA {
  font-weight: bold;
  font-size: 24px;
}
.FacultyCard_modal__qJErz .FacultyCard_modal-body__5ml0E {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.FacultyCard_modal__qJErz .FacultyCard_modal-body__5ml0E .FacultyCard_modal-content--title__thRRN {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  color: var(--accent-color);
  border-bottom: 1px solid var(--accent-color);
  padding-bottom: 4px;
}
.FacultyCard_modal__qJErz .FacultyCard_modal-body__5ml0E .FacultyCard_modal-content--content__XM4vr {
  margin-left: 20px;
}
.FacultyCard_modal__qJErz .FacultyCard_modal-body__5ml0E .FacultyCard_modal-content--content--item--statistics__9gdVm {
  display: flex;
  align-items: center;
  gap: 4px;
}
.FacultyCard_modal__qJErz .FacultyCard_modal-body__5ml0E .FacultyCard_modal-content--content--item--statistics__9gdVm svg path {
  stroke: var(--accent-color);
}

.FacultyCard_cited-by__2LVw\\+ {
  font-size: 10px;
  color: var(--grey);
  font-weight: bold;
}

@media only screen and (max-width: 480px) {
  .FacultyCard_faculty-card__MRP2q .FacultyCard_avatar__ds59P {
    width: 40px;
    border-radius: 8px;
  }
  .FacultyCard_faculty-card__MRP2q .FacultyCard_brief__v9WR1 .FacultyCard_faculty-name__URrsv {
    font-size: 16px;
    font-weight: 500;
  }
  .FacultyCard_faculty-card__MRP2q .FacultyCard_brief__v9WR1 .FacultyCard_faculty-name--wrapper__qcLnW {
    margin-bottom: 0;
  }
  .FacultyCard_faculty-card__MRP2q .FacultyCard_keywords__6FeME span:first-child {
    display: none;
  }
  .FacultyCard_faculty-card__MRP2q .FacultyCard_faculty-card__body__jDN5C {
    flex-direction: column;
    gap: 8px;
  }
  .FacultyCard_faculty-card__MRP2q .FacultyCard_faculty-card__body__right__wcj85 {
    max-width: initial;
    padding-left: 0;
    border-left: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/FacultyCard/FacultyCard.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACF;AAEI;EACE,aAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAFJ;AAKE;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAKI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAHN;AAKM;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAMM;EACE,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJR;AAQI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;AANN;AASI;EACE,gBAAA;EACA,kBAAA;EACA,iDAAA;AAPN;AAWE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AATJ;AAYE;EACE,eAAA;AAVJ;AAYI;EACE,0BAAA;AAVN;AAcE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAZJ;AAeE;EACE,2BAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,qBAAA;AAbJ;AAeI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAbN;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AAfJ;AAiBI;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;AAfN;AAmBE;EACE,yBAAA;AAjBJ;AAqBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAnBN;AAqBM;EACE,WAAA;EACA,YAAA;AAnBR;AAqBQ;EACE,kCAAA;AAnBV;AAyBE;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAvBJ;AAyBI;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvBN;AA2BM;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;EACA,+DAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzBR;AA2BQ;EACE,qCAAA;EACA,oBAAA;AAzBV;AA2BU;EACE,+BAAA;EACA,oBAAA;AAzBZ;AAgCE;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE;IACE,eAAA;IACA,iBAAA;EA/BJ;AACF;;AAoCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;AAjCJ;AAmCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAjCN;AAoCI;EACE,iBAAA;EACA,eAAA;AAlCN;AAsCE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApCJ;AAuCM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,0BAAA;EACA,4CAAA;EACA,mBAAA;AArCR;AAwCM;EACE,iBAAA;AAtCR;AAyCU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAvCZ;AA0Cc;EACE,2BAAA;AAxChB;;AAkDA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AA/CF;;AAkDA;EAEI;IACE,WAAA;IACA,kBAAA;EAhDJ;EAoDI;IACE,eAAA;IACA,gBAAA;EAlDN;EAoDM;IACE,gBAAA;EAlDR;EA0DI;IACE,aAAA;EAxDN;EA6DI;IACE,sBAAA;IACA,QAAA;EA3DN;EA6DM;IACE,kBAAA;IACA,eAAA;IACA,iBAAA;EA3DR;AACF","sourcesContent":[".faculty-card-wrapper {\n  height: 100%;\n}\n\n.faculty-card {\n  display: flex;\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n\n  div {\n    &:empty {\n      display: none;\n    }\n  }\n\n  &__top {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    align-self: stretch;\n  }\n\n  &__body {\n    display: flex;\n    padding: 10px;\n    justify-content: space-between;\n    align-items: flex-start;\n    align-self: stretch;\n\n    &--item {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n      gap: 4px;\n      align-self: stretch;\n\n      &--title {\n        color: var(--grey-text);\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n\n      &--value {\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        align-self: stretch;\n        color: var(--grey-text);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n    }\n\n    &__left {\n      display: flex;\n      padding-right: 16px;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 24px;\n      flex: 1 0 0;\n    }\n\n    &__right {\n      max-width: 319px;\n      padding-left: 16px;\n      border-left: 1px solid var(--accent-color-medium);\n    }\n  }\n\n  &__bottom {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    align-self: stretch;\n  }\n\n  .link {\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .avatar {\n    width: 60px;\n    aspect-ratio: 1/1;\n    border-radius: 8px;\n    object-fit: cover;\n  }\n\n  .faculty-name {\n    color: var(--explore-color);\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    /* 100% */\n    letter-spacing: 0.4px;\n\n    &--wrapper {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex: 1;\n    }\n  }\n\n  .entity-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n\n    :global(.MuiButton-root) {\n      box-sizing: border-box;\n      min-width: 130px;\n      min-height: 36px;\n    }\n  }\n\n  .favorite-btn {\n    text-transform: uppercase;\n  }\n\n  .statistics {\n    .statistic {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n\n      svg {\n        width: 32px;\n        height: 32px;\n\n        path {\n          stroke: var(--accent-color-medium);\n        }\n      }\n    }\n  }\n\n  .keywords {\n    max-height: 118px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n\n    span {\n      color: var(--grey-text);\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    .keywords {\n      &--item {\n        display: flex;\n        padding: 6px 12px;\n        align-items: center;\n        border-radius: 20px;\n        background: var(--light-grey);\n        color: var(--grey-text);\n        text-align: center;\n        font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n        font-size: 0.85rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        box-shadow: none;\n        text-transform: initial;\n\n        &.clickable {\n          background: var(--accent-color-light);\n          color: var(--text-1);\n\n          &:hover {\n            background: var(--accent-color);\n            color: var(--text-0);\n          }\n        }\n      }\n    }\n  }\n\n  .experience-information {\n    display: flex;\n    font-size: 13px;\n    color: var(--blue);\n    margin-top: 5px;\n    padding: 4px 8px;\n  }\n\n  @media only screen and (max-width: 480px) {\n    .institution {\n      font-size: 14px;\n      font-weight: bold;\n    }\n  }\n}\n\n.modal {\n  .modal-title {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    color: var(--accent-color);\n\n    &--avatar--photo {\n      width: 72px;\n      height: 72px;\n      border-radius: 50%;\n      object-fit: cover;\n    }\n\n    &--name {\n      font-weight: bold;\n      font-size: 24px;\n    }\n  }\n\n  .modal-body {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    .modal-content {\n      &--title {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        font-weight: 600;\n        color: var(--accent-color);\n        border-bottom: 1px solid var(--accent-color);\n        padding-bottom: 4px;\n      }\n\n      &--content {\n        margin-left: 20px;\n\n        &--item {\n          &--statistics {\n            display: flex;\n            align-items: center;\n            gap: 4px;\n\n            svg {\n              path {\n                stroke: var(--accent-color);\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.cited-by {\n  font-size: 10px;\n  color: var(--grey);\n  font-weight: bold;\n}\n\n@media only screen and (max-width: 480px) {\n  .faculty-card {\n    .avatar {\n      width: 40px;\n      border-radius: 8px;\n    }\n\n    .brief {\n      .faculty-name {\n        font-size: 16px;\n        font-weight: 500;\n\n        &--wrapper {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    .keywords {\n      // max-height: 56px;\n\n      span:first-child {\n        display: none;\n      }\n    }\n\n    .faculty-card {\n      &__body {\n        flex-direction: column;\n        gap: 8px;\n\n        &__right {\n          max-width: initial;\n          padding-left: 0;\n          border-left: none;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-card-wrapper": `FacultyCard_faculty-card-wrapper__L9a3p`,
	"faculty-card": `FacultyCard_faculty-card__MRP2q`,
	"faculty-card__top": `FacultyCard_faculty-card__top__6luiv`,
	"faculty-card__body": `FacultyCard_faculty-card__body__jDN5C`,
	"faculty-card__body--item": `FacultyCard_faculty-card__body--item__OiqrN`,
	"faculty-card__body--item--title": `FacultyCard_faculty-card__body--item--title__3w1uo`,
	"faculty-card__body--item--value": `FacultyCard_faculty-card__body--item--value__m6tJs`,
	"faculty-card__body__left": `FacultyCard_faculty-card__body__left__UVFya`,
	"faculty-card__body__right": `FacultyCard_faculty-card__body__right__wcj85`,
	"faculty-card__bottom": `FacultyCard_faculty-card__bottom__8cphp`,
	"link": `FacultyCard_link__Mwq9K`,
	"avatar": `FacultyCard_avatar__ds59P`,
	"faculty-name": `FacultyCard_faculty-name__URrsv`,
	"faculty-name--wrapper": `FacultyCard_faculty-name--wrapper__qcLnW`,
	"entity-actions": `FacultyCard_entity-actions__X3RXw`,
	"favorite-btn": `FacultyCard_favorite-btn__ABQx0`,
	"statistics": `FacultyCard_statistics__6AvOn`,
	"statistic": `FacultyCard_statistic__AQPgf`,
	"keywords": `FacultyCard_keywords__6FeME`,
	"keywords--item": `FacultyCard_keywords--item__Ps3B5`,
	"clickable": `FacultyCard_clickable__EYGb1`,
	"experience-information": `FacultyCard_experience-information__YLwRr`,
	"institution": `FacultyCard_institution__s1Fxv`,
	"modal": `FacultyCard_modal__qJErz`,
	"modal-title": `FacultyCard_modal-title__U0vjn`,
	"modal-title--avatar--photo": `FacultyCard_modal-title--avatar--photo__YdIth`,
	"modal-title--name": `FacultyCard_modal-title--name__rxdPA`,
	"modal-body": `FacultyCard_modal-body__5ml0E`,
	"modal-content--title": `FacultyCard_modal-content--title__thRRN`,
	"modal-content--content": `FacultyCard_modal-content--content__XM4vr`,
	"modal-content--content--item--statistics": `FacultyCard_modal-content--content--item--statistics__9gdVm`,
	"cited-by": `FacultyCard_cited-by__2LVw+`,
	"brief": `FacultyCard_brief__v9WR1`
};
export default ___CSS_LOADER_EXPORT___;
